<template>
      <layout-basic>
        <Breadcrumb/>
        <v-container fluid style="margin-bottom: 45px">
          <v-row>
            <v-col md="12">
              <HeaderComponent title="Resources" :subTitle="$globalConfig.APP_NAME === 'senso' ? 'Access and download essential Senso Learn documents.': 'Access and download essential Improve documents.'"/>
            </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
              <DocumentsComponent/>
            </v-col>
            </v-row>
            </v-container>
        </layout-basic>
  </template>
  
  <script>
  import LayoutBasic from '@/layouts/Dashboard';
  import DocumentsComponent from '@/components/DocumentsComponent.vue';
  import HeaderComponent from '@/components/HeaderComponent.vue';
  import Breadcrumb from '@/components/Breadcrumb';
  export default {
    name: 'Resources',
    components: {
      LayoutBasic,
      HeaderComponent,
      DocumentsComponent,
      Breadcrumb
  }
  }
  </script>
  
  <style scoped>
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
 }
  </style>
